// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class WorkflowCaseModel {
    static getAttributeTypeMap() {
        return WorkflowCaseModel.attributeTypeMap;
    }
}
WorkflowCaseModel.discriminator = undefined;
WorkflowCaseModel.additionalProperties = false;
WorkflowCaseModel.attributeTypeMap = [
    {
        "name": "workflowCaseId",
        "baseName": "workflowCaseId",
        "type": "number"
    },
    {
        "name": "tenantId",
        "baseName": "tenantId",
        "type": "number"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "workflowId",
        "baseName": "workflowId",
        "type": "number"
    },
    {
        "name": "displayId",
        "baseName": "displayId",
        "type": "string"
    },
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "typeCode",
        "baseName": "typeCode",
        "type": "string"
    },
    {
        "name": "typeDescription",
        "baseName": "typeDescription",
        "type": "string"
    },
    {
        "name": "statusId",
        "baseName": "statusId",
        "type": "number"
    },
    {
        "name": "statusCode",
        "baseName": "statusCode",
        "type": "string"
    },
    {
        "name": "statusDescription",
        "baseName": "statusDescription",
        "type": "string"
    },
    {
        "name": "subStatusId",
        "baseName": "subStatusId",
        "type": "number"
    },
    {
        "name": "subStatusCode",
        "baseName": "subStatusCode",
        "type": "string"
    },
    {
        "name": "subStatusDescription",
        "baseName": "subStatusDescription",
        "type": "string"
    },
    {
        "name": "assignedUserId",
        "baseName": "assignedUserId",
        "type": "number"
    },
    {
        "name": "isOpen",
        "baseName": "isOpen",
        "type": "boolean"
    },
    {
        "name": "previousCaseId",
        "baseName": "previousCaseId",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "isExpired",
        "baseName": "isExpired",
        "type": "boolean"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "updatedOn",
        "baseName": "updatedOn",
        "type": "Date"
    },
    {
        "name": "typeCategoryCode",
        "baseName": "typeCategoryCode",
        "type": "string"
    },
    {
        "name": "typeCategoryId",
        "baseName": "typeCategoryId",
        "type": "number"
    },
    {
        "name": "typeCategoryDescription",
        "baseName": "typeCategoryDescription",
        "type": "string"
    },
    {
        "name": "statusCategoryCode",
        "baseName": "statusCategoryCode",
        "type": "string"
    },
    {
        "name": "statusCategoryId",
        "baseName": "statusCategoryId",
        "type": "number"
    },
    {
        "name": "statusCategoryDescription",
        "baseName": "statusCategoryDescription",
        "type": "string"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "number"
    },
    {
        "name": "initiatorId",
        "baseName": "initiatorId",
        "type": "number"
    },
    {
        "name": "closedBy",
        "baseName": "closedBy",
        "type": "number"
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": ""
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": ""
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": ""
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": ""
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": ""
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": ""
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": ""
    },
];
//# sourceMappingURL=workflowCaseModel.js.map